import { render } from "./Swatch.vue?vue&type=template&id=4647558e"
import script from "./Swatch.vue?vue&type=script&lang=js"
export * from "./Swatch.vue?vue&type=script&lang=js"

import "./Swatch.vue?vue&type=style&index=0&id=4647558e&lang=stylus"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__